// extracted by mini-css-extract-plugin
module.exports = {"item":"activityItem_item_m6VL9","itemtop":"activityItem_itemtop_TDSg2","itembottom":"activityItem_itembottom_1VUMS","btn":"activityItem_btn_2TaMX"};